import { detectDrmProfile, rewriteManifestUrl } from '@app/shared/utils/streaming-url.utils';

interface StreamingAdjustParams {
  mediaRecordData: any;
  platformId: Object;
}

/**
 * ブラウザ種別ごとに MediaKind の manifest URL を調整する。
 * 判定・書き換えロジックは streaming-url.utils に集約（Safari/iOS は
 * HLS + cbcs-aapl、それ以外は DASH + cenc）。
 */
export function adjustStreamingUrlForBrowser(params: StreamingAdjustParams): void {
  const { mediaRecordData } = params;
  if (!mediaRecordData) {
    return;
  }

  const profile = detectDrmProfile();
  const updatedUrl = rewriteManifestUrl(
    mediaRecordData.data?.storage?.streamingURL,
    profile,
  );

  if (updatedUrl) {
    mediaRecordData.data.storage.streamingURL = updatedUrl;
  }
}
